import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const AREN_LOCALE_STORAGE_KEY = 'aren.ui.locale';
const defaultLanguage =
	typeof window !== 'undefined'
		? window.localStorage.getItem(AREN_LOCALE_STORAGE_KEY) || 'fa'
		: 'fa';

const getLoginBasePath = () => {
	if (typeof window === 'undefined') return '';
	if (window.location.pathname.startsWith('/aren-admin/static/login')) {
		return '/aren-admin/static/login';
	}
	if (window.location.pathname.startsWith('/static/login')) {
		return '/static/login';
	}
	return '';
};

const loginBasePath = getLoginBasePath();

if (typeof document !== 'undefined') {
	const isRtl = defaultLanguage === 'fa' || defaultLanguage.startsWith('fa-');
	document.documentElement.setAttribute('lang', defaultLanguage);
	document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
	document.body?.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
}

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		react: {
			useSuspense: false
		},
		lng: defaultLanguage,
		// English is the source language of every inline t() default, so it is the
		// right fallback: a key missing from one locale must not leak Persian text
		// into the English UI.
		fallbackLng: 'en',
		detection: {
			order: ['localStorage', 'navigator'],
			lookupLocalStorage: 'aren.ui.locale'
		},
		debug: false,
		interpolation: {
			escapeValue: false // react already safes from xss
		},
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		missingKeyHandler: (lng, ns, key, fallbackValue) => {
			// eslint-disable-next-line no-console
			console.warn('Missing translation with key', key);
		},
		backend: {
			loadPath: `${loginBasePath}/i18n/{{lng}}.json`
		}
	});

export default i18n;
